import React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { connect } from "react-redux"

import NavBarContainer from "./navbar/NavBarContainer"
import AlertsContainer from "./alerts/AlertsContainer"

const Main = ({ routes, location: { pathname }, redirectPath }) => (
    <div id="db-wrapper">
        {pathname === "/" && redirectPath && <Redirect to={redirectPath} />}
        <div className="db-row">
            <div className="no-padding sidebar-col">
                <NavBarContainer />
            </div>
            <div className="col-xs-12 col-md-12 col-lg-12 no-padding db-view-container">
                <AlertsContainer />
                {routes.map(route => {
                    if (route.switch) {
                        return (
                            <Switch key={route.path}>
                                {route.switch.map(switchRoute => (
                                    <Route
                                        key={switchRoute.path}
                                        path={switchRoute.path}
                                        component={switchRoute.component}
                                    />
                                ))}
                            </Switch>
                        )
                    } else
                        return (
                            <Route
                                key={route.path}
                                path={route.path}
                                component={route.component}
                            />
                        )
                })}
            </div>
        </div>
    </div>
)

const mapStateToProps = ({ routes }) => ({
    routes
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Main)
